import dayjs from 'dayjs';

import { BatchStatus, CreationMethod, SortingBatch } from '../types';

export const ALL = 'all';

export interface BatchFilters {
    batchNumber: string;
    creationSite: string;
    /** 创建日期范围（YYYY/MM/DD，含首尾） */
    createdRange: [string | null, string | null] | null;
    destination: string;
    status: BatchStatus | typeof ALL;
    creationMethod: CreationMethod | typeof ALL;
}

export const DEFAULT_BATCH_FILTERS: BatchFilters = {
    batchNumber: '',
    creationSite: ALL,
    createdRange: null,
    destination: ALL,
    status: ALL,
    creationMethod: ALL,
};

const inDateRange = (time: number, range: BatchFilters['createdRange']): boolean => {
    if (!range) return true;
    const [from, to] = range;
    if (from && dayjs(time).isBefore(dayjs(from).startOf('day'))) return false;
    if (to && dayjs(time).isAfter(dayjs(to).endOf('day'))) return false;
    return true;
};

/** 列表筛选：批次号模糊（不区分大小写）、创建地、创建日期、目的地、状态、创建方式 */
export const filterBatches = <T extends SortingBatch>(rows: T[], f: BatchFilters): T[] => {
    const q = f.batchNumber.trim().toLowerCase();
    return rows.filter((b) => (!q || b.batchNumber.toLowerCase().includes(q))
        && (f.creationSite === ALL || b.creationSite === f.creationSite)
        && inDateRange(b.createdAt, f.createdRange)
        && (f.destination === ALL || b.destination === f.destination)
        && (f.status === ALL || b.status === f.status)
        && (f.creationMethod === ALL || b.creationMethod === f.creationMethod));
};

const uniq = (arr: string[]): string[] => Array.from(new Set(arr.filter(Boolean))).sort();

/** 筛选下拉选项：从当前 tab 的批次派生 */
export const filterOptionsOf = (rows: SortingBatch[]): { creationSites: string[]; destinations: string[] } => ({
    creationSites: uniq(rows.map((b) => b.creationSite)),
    destinations: uniq(rows.map((b) => b.destination)),
});
